import React from 'react';
import '../../../layout/styles/LoaderDots.css';

const LoaderDots = () => {
  return (
    <div className="dot-loader">
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default LoaderDots;